import ListingDetails from '../views/client/listing-details';

export default ListingDetails;
